import { Feedback } from '@saleshandy/icons';
import React from 'react';
import useBetterBugsIntegrationWithConfig from '../../../../../shared/hooks/script-integrations/useBetterBugsIntegrationWithConfig';
import {
  getUserEmail,
  getUserLeadFinderPlanName,
  getUserPlanCode,
  getUserId,
  getUserPlanName,
  getUserShAccountId,
  getUserLeadFinderPlanCode,
  getUserInboxAnalyzerPlanName,
  getUserInboxAnalyzerPlanCode,
} from '../../../../../shared/utils/user-details';

const BetterBugButton = () => {
  // Use the BetterBugs integration hook
  useBetterBugsIntegrationWithConfig({
    enable: true,
  });

  const handleBetterBug = () => {
    // Access BetterBugs instance from global window object
    const { betterBugsInstance } = window as any;
    if (
      betterBugsInstance &&
      typeof betterBugsInstance.openWidget === 'function'
    ) {
      if (!betterBugsInstance.email) {
        betterBugsInstance?.setEmail(getUserEmail());
        betterBugsInstance?.setMetadata({
          shAccountId: getUserShAccountId(),
          userId: getUserId(),
          emailAccount: getUserEmail(),
          currentPlanName: getUserPlanName(),
          currentPlanCode: getUserPlanCode(),
          currentLFPlanName: getUserLeadFinderPlanName(),
          currentLFPlanCode: getUserLeadFinderPlanCode(),
          currentIAPlanName: getUserInboxAnalyzerPlanName(),
          currentIAPlanCode: getUserInboxAnalyzerPlanCode(),
        });
      }
      betterBugsInstance.openWidget();
    }
  };

  return (
    <button
      type="button"
      className="app-sidebar__nav-item-container chat-button"
      onClick={handleBetterBug}
    >
      <div className="app-sidebar__nav-item">
        <div className="nav-item-left">
          <div className="nav-item-icon">
            <Feedback />
          </div>
          <span className="nav-item-text">Submit Feedback</span>
        </div>

        <div className="nav-item-right" />
      </div>
    </button>
  );
};

export default BetterBugButton;
